import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import levitonLogo from './asset/images/leviton_logo.png';
import phoneLogo from './asset/icons/call-outline.svg';
import mailLogo from './asset/icons/mail-outline.svg';
import internetLogo from './asset/icons/globe-outline.svg';
import signalLogo from './asset/icons/radio-outline.svg';
import { motion } from "motion/react"

declare var NDEFWriter: any;

const BusinessCard = () => {
    const {id} = useParams();
    const [userData, setUserData] = useState(null);
    let userId = id || null;

    // Save data to cache
    const saveData = (key, value) => {
        try {
            // console.log('saveData()', key, value);
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.log('saveData() ERROR: ', e);
        }
    };

    // Retrieve data from cache
    const getData = (key) => {
        let cachedData = null;
        try {
            cachedData = localStorage.getItem(key);
            // console.log('cache GET', key, cachedData);
            return cachedData ? JSON.parse(cachedData) : null;
        } catch (e) {
            // console.log('getData() ERROR: ', key, cachedData);
            return cachedData;
        }
    };

    if (userId) {
        saveData('lastPath', userId);
    } else {
        userId = getData('lastPath');
    }

    // updateManifest();
    // if ('serviceWorker' in navigator) {
    //     window.addEventListener('load', () => {
    //         console.log('window load');
    //         navigator.serviceWorker.register('/service-worker.js');
    //     });
    // }

    const saveContact = async () => {
        const contact = {
            name: userData.name,
            phone: userData.phone,
            email: userData.email,
            company: "Leviton Manufacturing Co., Inc.",
        };
        // console.log('saving contact: ', contact);
        // create a vcard file
        const vcard = "BEGIN:VCARD\nVERSION:4.0\nFN:" + contact.name + "\nTEL;TYPE=work,voice:" + contact.phone + "\nEMAIL:" + contact.email + "\nEND:VCARD";
        const blob = new Blob([vcard], {type: "text/vcard"});
        const url = URL.createObjectURL(blob);
        const newLink = document.createElement('a');
        newLink.download = contact.name + ".vcf";
        newLink.textContent = contact.name;
        newLink.href = url;

        newLink.click();
    }

    useEffect(() => {
        let localUserData = {};

        const localSetUserData = (data) => {
            setUserData(data);
            localUserData = data;
        }

        const updateManifest = (userData) => {
            console.log('updateManifest: ', userId, userData);

            const manifest = {
                "short_name": (userData && userData.name) || "Leviton Card",
                "name": "Leviton Digital Business Card",
                "icons": [
                    {
                        "src": `${window.location.origin}/favicon.ico`,
                        "sizes": "64x64 32x32 24x24 16x16",
                        "type": "image/x-icon"
                    },
                    {
                        "src": `${window.location.origin}/logo192.png`,
                        "type": "image/png",
                        "sizes": "192x192"
                    },
                    {
                        "src": `${window.location.origin}/logo512.png`,
                        "type": "image/png",
                        "sizes": "512x512"
                    }
                ],
                "start_url": `${window.location.origin}/${userId}`, // Set dynamic start_url here
                "display": "standalone",
                "theme_color": "#76B900",
                "background_color": "#222c38"
            };

            const stringManifest = JSON.stringify(manifest);
            const blob = new Blob([stringManifest], { type: 'application/json' });
            const manifestURL = URL.createObjectURL(blob);

            const manifestLink = document.querySelector('#manifest-link');
            manifestLink.href = manifestURL;
            console.log('new manifest: ', window, manifest);
        };

        const writeNFC = async () => {
            if ('NDEFWriter' in window) {
                try {
                    const ndef = new NDEFWriter();
                    await ndef.write({
                        records: [
                            {
                                recordType: "text",
                                data: `BEGIN:VCARD\nVERSION:3.0\nFN:${localUserData.name}\nTEL:${localUserData.phone}\nEMAIL:${localUserData.email}\nORG:${localUserData.company}\nTITLE:${localUserData.position}\nEND:VCARD`
                            }
                        ]
                    });
                    // alert("NFC tag written successfully!");
                    console.log('NFC tag written successfully!')
                } catch (error) {
                    console.error("Error writing NFC tag:", error);
                }
            } else {
                // alert("Web NFC is not supported on this device.");
            }
        };

        const fetchUserData = async () => {
            console.log('fetching user data: ', userId);
            const dataKey = `user/${userId}`;
            writeNFC();
            let data = getData(dataKey);
            localSetUserData(data);
            const response = await fetch(`https://nn19w1ez87.execute-api.us-east-1.amazonaws.com/user/${userId}`);
            console.log('raw response: ', response);
            data = await response.json();
            localSetUserData(data);
            saveData(dataKey, data);
            updateManifest(data);
        };

        fetchUserData();
    }, [userId]);


    const transition = {
        duration: 0.8,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
    }

    const iconsTransition = {
        duration: 0.5,
        delay: 1
    }

    if (!userData) return <div className="center-loading">Loading...</div>;

    return (
        <div className="business-card" id="business-card">
            <motion.div className="top-container"
                        initial={{ y: '-110%', opacity: 1}}
                        animate={{ y: 0, opacity: 1 }}
                        transition={transition}>
                <motion.img className="logo-top-right" src={signalLogo} alt="Signal Icon"
                     initial={{ opacity: 0}}
                     animate={{ opacity: 1 }}
                     transition={iconsTransition}
                />
                <img className="bc__face"
                     src={`https://leviton-business-cards.s3.us-east-1.amazonaws.com/images/${userId}.webp`}
                     alt="Face"/>
                <h1 className="name-container">{userData.name}</h1>
                <p className="title-container">{userData.title}</p>
                <p className="company-container">Leviton Manufacturing Co., Inc.</p>
                <p className="email-container">{userData.email} | {userData.phone}</p>
            </motion.div>
            <motion.div className="icons-position"
                        initial={{ opacity: 0}}
                        animate={{ opacity: 1 }}
                        transition={iconsTransition}>
                <div></div>
                <a href={"tel:" + userData.phone}>
                    <button className="three-icons">
                        <img src={phoneLogo} alt="Phone Icon"></img>
                    </button>
                </a>
                <a href={"mailto:" + userData.email}>
                    <button className="three-icons middle-icon-margin">
                        <img src={mailLogo} alt="Mail Icon"></img>
                    </button>
                </a>
                <a href={userData.website} target="_blank" rel="noreferrer">
                    <button className="three-icons">
                        <img src={internetLogo} alt="Web Icon"></img>
                    </button>
                </a>
                <div></div>
            </motion.div>
            <motion.div
                initial={{ y: '150%' }}
                animate={{ y: 0 }}
                transition={transition}
                className="bottom-container">
                <div className="qr-content">
                    <img className="bc__qr"
                         src={`https://leviton-business-cards.s3.us-east-1.amazonaws.com/qr-codes/${userId}.png`}
                         alt="QR Code"/>
                    <button className="contact-class" onClick={saveContact}> Save Contact</button>
                    <motion.img className="logo-bottom-right" src={levitonLogo} alt="Logo"
                         initial={{ opacity: 0}}
                         animate={{ opacity: 1 }}
                         transition={iconsTransition}
                    ></motion.img>
                </div>
            </motion.div>
        </div>
    );
};

export default BusinessCard;
